<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler" >
            <el-form-item slot="title">
                <el-input v-model="pgData.zbproname" style="width:100%;" placeholder="项目名称" clearable=""></el-input>
            </el-form-item>
            <el-form-item slot="time">
                <el-input v-model="pgData.zbprocode" style="width:100%;" placeholder="项目编号" clearable=""></el-input>
            </el-form-item>    
            <template slot="btn">           
            </template>
        </my-search>
        <my-table :data="tableData" :height="566">
            <el-table-column label="项目名称" prop="zbproname"  min-width="200">
            </el-table-column>
            <el-table-column label="项目编号" prop="zbprocode" min-width="120">
            </el-table-column>
            <el-table-column label="添加时间" prop="addtime" min-width="200">
            </el-table-column>
            <el-table-column label="操作"  min-width="200">
                <template slot-scope="scope">                
                    <div >
                        <el-button type="text" @click="goto(scope.row.zbprocode)">
                            进入控制台
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('ageUrl')}/Zbdl/tuihui/zbprojectlist.json`">
        </my-pagination>
        <my-dialog title="控制台" v-model="dialogVisible" width="1150px">
            <console :zbprocode="zbprocode" v-if="dialogVisible" ></console>
        </my-dialog>
    </div>
    
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import console from './console.vue'
export default {
    components: { console },
    mixins: [LIST_PAGE_MIXIN],
    data: () => ({
        tableData:[],
        pgData: {
            pagesize: 20,
            sortname:'addtime'
        },
        dialogVisible:false,
        zbprocode:'',
    }),
    methods: {
        change() {
            this.searchHandler()
        },
        goto(zbprocode,bdcode) {
            this.dialogVisible=true
            this.zbprocode=zbprocode
            this.bdcode=bdcode
            // this.goto({
            //     path: './kongzhitai',
            //     query: {
            //         zbprocode: zbprocode,
            //     }
            // });
        }
    },
    mounted() {
      
    },
    created(){
        var that = this

    }
};
</script>

<style scoped lang="scss">
</style>
